module.exports = __webpack_public_path__ + "img/sidebar.4de6e65e.jpg";